import React from 'react';

export default function About() {
  return (
    <div
      style={{
        width: '100vw',
        minHeight: '100vh',
        marginLeft: 'calc(50% - 50vw)',
        marginRight: 'calc(50% - 50vw)',
        padding: '28px 0px',
        backgroundImage: "linear-gradient(rgba(15, 23, 42, 0.4), rgba(15, 23, 42, 0.4)), url('/images/earth-blue-marble.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div style={{ userSelect: 'none', maxWidth: '760px', margin: '0 auto', padding: '32px', background: 'hsla(0, 0%, 100%, 0.80)', borderRadius: '25px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
        <h1 style={{ fontSize: '2.25rem', fontWeight: 700, marginBottom: '1.25rem', color: '#2c3e50' }}>Adam Roysson</h1>
        <p>
          With a background in the <strong>Swedish Navy</strong>, I bring discipline, structure, and efficiency to my work as a <strong>GIS specialist</strong>.
          I am passionate about GIS and recognized as a reliable and supportive team member who enjoys helping others succeed.
        </p>

        <h2 style={{ fontSize: '1.4rem', fontWeight: 600, marginTop: '2rem', marginBottom: '0.6rem', color: '#2980b9' }}>Skills</h2>
        <p style={{ lineHeight: 1.8, color: '#333' }}>
          <strong>GIS Tools:</strong> ArcGIS Pro, ArcGIS Online, ArcGIS Enterprise, QGIS, FME, VS Code, VS Studio, OSM
          <br />
          <strong>Programming Languages:</strong> Python, C#, Arcade, JS, HTML
        </p>

        <h2 style={{ fontSize: '1.4rem', fontWeight: 600, marginTop: '2rem', marginBottom: '0.6rem', color: '#2980b9' }}>Work Experience</h2>

        <h3 style={{ fontSize: '1.1rem', fontWeight: 700, marginTop: '1.2rem', marginBottom: '0.2rem', color: '#1f2937' }}>GIS Specialist</h3>
        <p style={{ marginTop: 0, marginBottom: '0.5rem', color: '#4b5563' }}>2023 - Ongoing</p>
        <p style={{ marginTop: 0, marginBottom: '0.5rem', color: '#4b5563' }}>Swedish Armed Forces</p>
        <p style={{ lineHeight: 1.8, color: '#333' }}>
          Serve as GIS Administrator for an enterprise geoportal based on Esri ArcGIS Enterprise.
          Responsible for system management, data publishing, user access, and platform development.
          Support operational and strategic decision-making through geospatial analysis and visualization.
        </p>

        <h3 style={{ fontSize: '1.1rem', fontWeight: 700, marginTop: '1.2rem', marginBottom: '0.2rem', color: '#1f2937' }}>Environmental - and GIS administrator</h3>
        <p style={{ marginTop: 0, marginBottom: '0.5rem', color: '#4b5563' }}>2018 - 2023</p>
        <p style={{ marginTop: 0, marginBottom: '0.5rem', color: '#4b5563' }}>Naval Base Swedish Armed Forces</p>
        <p style={{ lineHeight: 1.8, color: '#333' }}>
          Managed the local GIS function at the naval base, including both short- and long-term planning, development, and budgeting.
          Supported environmental operations with GIS in urban planning and military exercise planning.
          Delivered GIS training and courses within the garrison.
        </p>

        <h3 style={{ fontSize: '1.1rem', fontWeight: 700, marginTop: '1.2rem', marginBottom: '0.2rem', color: '#1f2937' }}>Project- and logistic assistant</h3>
        <p style={{ marginTop: 0, marginBottom: '0.5rem', color: '#4b5563' }}>2017-03 - 2018-03</p>
        <p style={{ marginTop: 0, marginBottom: '0.5rem', color: '#4b5563' }}>Naval Base Swedish Armed Forces</p>
        <p style={{ lineHeight: 1.8, color: '#333' }}>
          Part of the Navy's logistics operations (LOGOPS), supporting both urgent and long-term logistical needs.
          Maintained and developed the logistics overview board for operational planning.
          Provided support in GIS, project coordination, command functions, and office administration.
        </p>

        <h3 style={{ fontSize: '1.1rem', fontWeight: 700, marginTop: '1.2rem', marginBottom: '0.2rem', color: '#1f2937' }}>Force protection soldier</h3>
        <p style={{ marginTop: 0, marginBottom: '0.5rem', color: '#4b5563' }}>2013-05 - 2017-03</p>
        <p style={{ lineHeight: 1.8, color: '#333' }}>
          Responsible for the protection and security of Karlskrona Garrison.
          Served as military guard and staff assistant within the platoon.
          Contributed to operational readiness and daily security operations.
        </p>

        <h2 style={{ fontSize: '1.4rem', fontWeight: 600, marginTop: '2rem', marginBottom: '0.6rem', color: '#2980b9' }}>Education & Courses</h2>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '24px' }}>
          <div style={{ flex: '1 1 320px' }}>
            <h3 style={{ fontSize: '1.1rem', fontWeight: 700, marginTop: '0.5rem', marginBottom: '0.6rem', color: '#1f2937' }}>Education</h3>
            <p style={{ lineHeight: 1.85, color: '#333', margin: 0 }}>
              <strong>Geographic Information Systems (GIS)</strong>
              <br />
              University of Gothenburg - 2022
              <br />
              <br />
              <strong>Group Commander Course</strong>
              <br />
              Swedish Naval Warfare Centre - 2018
              <br />
              <br />
              <strong>Nautical Deck Officer, Class 8</strong>
              <br />
              Swedish Naval Warfare Centre - 2016
              <br />
              <br />
              <strong>Basic Military Training</strong>
              <br />
              Swedish Naval Warfare Centre - 2013
            </p>
          </div>

          <div style={{ flex: '1 1 280px' }}>
            <h3 style={{ fontSize: '1.1rem', fontWeight: 700, marginTop: '0.5rem', marginBottom: '0.6rem', color: '#1f2937' }}>Additional Courses</h3>
            <p style={{ lineHeight: 1.95, color: '#333', margin: 0 }}>
              Python for GIS (Esri)
              <br />
              Nordic GIS Course (NORDEFCO)
              <br />
              Defence Energy Manager Course
              <br />
              PRINCE2 Foundation &amp; Practitioner
              <br />
              Using ArcGIS for Geospatial Intelligence
              <br />
              Environmental Work in the Armed Forces
              <br />
              Logistics in Maritime Operations (Navy)
            </p>
          </div>
        </div>

        <h2 style={{ fontSize: '1.4rem', fontWeight: 600, marginTop: '2rem', marginBottom: '0.6rem', color: '#2980b9' }}>Language Skills</h2>
        <p style={{ lineHeight: 1.9, color: '#333' }}>
          Swedish - Native
          <br />
          English - Fluent
          <br />
          French - A1
          <br />
          German - Beginner
        </p>
      </div>
    </div>

  );
}